import { useState } from "react";
import React, { CircularProgress, Modal } from "@mui/material";
import { useUserData } from "components/customHooks/userDataContext";
import { updateEncounterDetails } from "apiHandler/actions";
import { displayDateFormatter } from "components/helpers";
import PatientPicker from "components/UI/PatientPicker";

const initial_error = {
  patient: false,
  provider: false,
  location: false,
  dos: false,
};
const PatientPickerModal = ({ onClose, dictation_id, appointemnt_data }) => {
  const userData = useUserData();
  const [error, setError] = useState({ ...initial_error });
  const [loading, setLoading] = useState(false);

  // Input states
  const [patient, setPatient] = useState({});

  const token = userData?.access_token;

  const validate = () => {
    let isValid = true;
    let errorstate = { ...initial_error };
    if (!patient.patient_id) {
      isValid = false;
      errorstate.patient = true;
    }
    setError(errorstate);
    return isValid;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const patientPayload = {
      type: "Encounter",
      record_data: {
        practice_id: userData?.selected_practice,
        patient_id: patient.patient_id,
        dictation_id: dictation_id,
        scribe_id: userData.email,
        dob: displayDateFormatter(patient.dob),
        first_name: patient.first_name,
        last_name: patient.last_name,
        user_name: userData.first_name + " " + userData.last_name,
      },
    };
    const patientData = await updateEncounterDetails(patientPayload, token);
    console.log("patientData----", patientData);
    if (patientData) {
      onClose();
      setLoading(false);
    }
  };
  return (
    <Modal open={true} onClose={() => {}}>
      <form className="add-appointment-modal">
        <h1>Search Patient</h1>
        <div className="input-div">
          <div className="label"> Patient </div>
          <div className="input">
            <PatientPicker
              value={patient}
              setValue={setPatient}
              error={error.patient}
            />
          </div>
        </div>
        <div className="btn-cont">
          <button type="submit" onClick={onSubmit} className="save">
            {loading ? (
              <CircularProgress color="#fff" size={16} />
            ) : appointemnt_data ? (
              "Update"
            ) : (
              "Attach"
            )}
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              if (loading) return;
              onClose();
            }}
            className="cancel"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default PatientPickerModal;
